// Lightweight client-side "optimize": re-save through pdf-lib with object
// streams, which removes slack and can shrink lightly-bloated PDFs. This is NOT
// a heavy recompressor — image-heavy scans need the backend (Milestone C).
import { PDFDocument } from "pdf-lib";

export interface CompressResult {
  bytes: Uint8Array;
  before: number;
  after: number;
  savedPct: number;
}

export const compressClient = async (bytes: Uint8Array): Promise<CompressResult> => {
  const doc = await PDFDocument.load(bytes, { ignoreEncryption: true });
  const out = await doc.save({ useObjectStreams: true });
  const before = bytes.byteLength;
  const after = out.byteLength;
  return {
    bytes: out,
    before,
    after,
    savedPct: before > 0 ? Math.max(0, Math.round((1 - after / before) * 100)) : 0,
  };
};
